
module.exports = function PasswordStrength ($host, config) {

  // Config
  var minThreshold = 10;
  var invalidClass = 'is-invalid';

  var STRENGTH_CHECKING_SUPPORTED = (typeof zxcvbn === 'function');

  // Dom
  var $input     = $('[type=password]',            $host);
  var $indicator = $('[data-threshold-indicator]', $host);
  var $icons     = $('[data-password-strength]',   $host);

  // External config can set threshold if it wants
  if (config.minThreshold) minThreshold = config.minThreshold;

  // Functions
  function setIcon (ix) {
    $icons.each(function () {
      $(this).toggle($(this).data('password-strength') === ix);
    });
  }

  function checkStrength (password) {
    return STRENGTH_CHECKING_SUPPORTED ? Math.min(3, zxcvbn(password).score) : 0;
  }

  function setIndicator (state) {
    $indicator.toggleClass(invalidClass, !state);
  }

  function checkPassword () {
    var password = $input.val();
    setIndicator(password.length >= minThreshold);
    setIcon(log(checkStrength(password)));
  }

  // Listeners
  $input.on('change keyup keydown paste', checkPassword);

  // Init
  setIcon(0);

}

